var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"entry",on:{"touchmove":_vm.touchmove,"touchend":_vm.touchend}},[_c('navigator',{attrs:{"id":_vm.currentPage},on:{"linkTo":_vm.linkTo}}),_vm._v(" "),_c('language-switcher'),_vm._v(" "),_c('index',{class:{
      currentPage: _vm.currentPage === 0,
      prePage: _vm.currentPage > 0,
      nextPage: _vm.currentPage < 0
    },attrs:{"id":"0"}}),_vm._v(" "),_c('introductions',{class:{
      currentPage: _vm.currentPage === 1,
      prePage: _vm.currentPage > 1,
      nextPage: _vm.currentPage < 1
    },attrs:{"id":"1"}}),_vm._v(" "),_c('skills',{class:{
      currentPage: _vm.currentPage === 2,
      prePage: _vm.currentPage > 2,
      nextPage: _vm.currentPage < 2
    },attrs:{"id":"2","show":_vm.currentPage === 2}}),_vm._v(" "),_c('works',{class:{
      currentPage: _vm.currentPage === 3,
      prePage: _vm.currentPage > 3,
      nextPage: _vm.currentPage < 3
    },attrs:{"id":"3"}}),_vm._v(" "),_c('projects',{class:{
      currentPage: _vm.currentPage === 4,
      prePage: _vm.currentPage > 4,
      nextPage: _vm.currentPage < 4
    },attrs:{"id":"4","show":_vm.currentPage === 4}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-814dd936","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 